// extracted by mini-css-extract-plugin
export var inline = "RotatingMedia-module--inline--3d26d";
export var media = "RotatingMedia-module--media--0aaf1";
export var mediaSet = "RotatingMedia-module--media-set--7fa68";
export var section = "RotatingMedia-module--section--76dac";
export var visible = "RotatingMedia-module--visible--c9b88";